var _style, _path, _path2, _path3, _path4, _path5, _path6, _g, _g2, _g3, _g4, _defs, _defs2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _defs3, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _defs4, _defs5, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _rect289, _rect290, _rect291, _rect292, _rect293, _rect294, _rect295, _rect296, _defs6, _g5, _rect297, _g6, _g7, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _rect298, _g8, _g9, _g10, _g11, _g12, _g13, _rect299, _line19, _line20, _line21, _line22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThemeAdvanced(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1334 854",
    style: {
      enableBackground: "new 0 0 1334 854"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#099DBE;}\r\n\t.st1{fill:#D2D2D2;}\r\n\t.st2{clip-path:url(#SVGID_4_);fill:#099DBE;}\r\n\t.st3{clip-path:url(#SVGID_10_);fill:#099DBE;}\r\n\t.st4{opacity:0.29;fill:#099DBE;}\r\n\t.st5{fill:none;stroke:#099DBE;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#D2D2D2;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st7{fill:none;stroke:#D2D2D2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:#099DBE;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st9{fill:none;stroke:#099DBE;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:7.2561,7.2561;}\r\n\t.st10{fill:none;stroke:#099DBE;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:7.093,7.093;}\r\n\t.st11{fill:none;stroke:#D2D2D2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:6.6284,6.6284;}\r\n\t.st12{fill:none;stroke:#D2D2D2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:7.9109,7.9109;}\r\n\t.st13{fill:none;stroke:#D2D2D2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:7.631,7.631;}\r\n\t.st14{fill:none;stroke:#D2D2D2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:6.8938,6.8938;}\r\n\t.st15{fill:none;stroke:#D2D2D2;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st16{fill:none;stroke:#D2D2D2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:3.0168,3.0168;}\r\n\t.st17{fill:none;stroke:#D2D2D2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:3.043,3.043;}\r\n\t.st18{fill:none;stroke:#D2D2D2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:3.0694,3.0694;}\r\n\t.st19{fill:none;stroke:#D2D2D2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:3.0195,3.0195;}\r\n\t.st20{fill:none;stroke:#D2D2D2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:2.9033,2.9033;}\r\n\t.st21{fill:none;stroke:#D2D2D2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:3.0353,3.0353;}\r\n\t.st22{fill:none;stroke:#D2D2D2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:3.0608,3.0608;}\r\n\t.st23{fill:none;stroke:#D2D2D2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:3.0945,3.0945;}\r\n\t.st24{fill:none;stroke:#D2D2D2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:3.0817,3.0817;}\r\n\t.st25{fill:none;stroke:#099DBE;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st26{fill:none;stroke:#099DBE;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:2.9353,2.9353;}\r\n\t.st27{fill:none;stroke:#D2D2D2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:7.3998,7.3998;}\r\n\t.st28{fill:none;stroke:#D2D2D2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:6.6146,6.6146;}\r\n\t.st29{fill:none;stroke:#D2D2D2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:6.7847,6.7847;}\r\n\t.st30{fill:none;stroke:#D2D2D2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:7.5173,7.5173;}\r\n\t.st31{fill:none;stroke:#D2D2D2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:7.1876,7.1876;}\r\n\t.st32{fill:none;stroke:#D2D2D2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:7.4582,7.4582;}\r\n\t.st33{fill:none;stroke:#D2D2D2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:6.7657,6.7657;}\r\n\t.st34{fill:none;stroke:#D2D2D2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:7.1298,7.1298;}\r\n\t.st35{fill:none;stroke:#D2D2D2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:7.4482,7.4482;}\r\n\t.st36{fill:none;stroke:#D2D2D2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:7.107,7.107;}\r\n\t.st37{opacity:0.29;}\r\n\t.st38{fill:none;stroke:#099DBE;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st39{clip-path:url(#SVGID_16_);fill:#099DBE;}\r\n\t.st40{clip-path:url(#SVGID_22_);fill:#099DBE;}\r\n\t.st41{fill:none;stroke:#099DBE;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:6.6119,6.6119;}\r\n\t.st42{fill:none;stroke:#099DBE;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:7.3276,7.3276;}\r\n\t.st43{fill:none;stroke:#D2D2D2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:6.8517,6.8517;}\r\n\t.st44{fill:none;stroke:#D2D2D2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:6.3659,6.3659;}\r\n\t.st45{fill:none;stroke:#D2D2D2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:7.9085,7.9085;}\r\n\t.st46{fill:none;stroke:#D2D2D2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:7.1296,7.1296;}\r\n\t.st47{fill:none;stroke:#D2D2D2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:2.9524,2.9524;}\r\n\t.st48{fill:none;stroke:#D2D2D2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:2.9599,2.9599;}\r\n\t.st49{fill:none;stroke:#D2D2D2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:2.9626,2.9626;}\r\n\t.st50{fill:none;stroke:#D2D2D2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:2.9009,2.9009;}\r\n\t.st51{fill:none;stroke:#D2D2D2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:2.9962,2.9962;}\r\n\t.st52{fill:none;stroke:#D2D2D2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:2.9543,2.9543;}\r\n\t.st53{fill:none;stroke:#D2D2D2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:2.9568,2.9568;}\r\n\t.st54{fill:none;stroke:#D2D2D2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:2.9042,2.9042;}\r\n\t.st55{fill:none;stroke:#099DBE;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:3.0304,3.0304;}\r\n\t.st56{fill:none;stroke:#D2D2D2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:6.4703,6.4703;}\r\n\t.st57{fill:none;stroke:#D2D2D2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:6.8323,6.8323;}\r\n\t.st58{fill:none;stroke:#D2D2D2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:7.0058,7.0058;}\r\n\t.st59{fill:none;stroke:#D2D2D2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:6.7296,6.7296;}\r\n\t.st60{fill:none;stroke:#D2D2D2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:7.428,7.428;}\r\n\t.st61{fill:none;stroke:#D2D2D2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:7.7304,7.7304;}\r\n\t.st62{fill:none;stroke:#D2D2D2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:6.9976,6.9976;}\r\n\t.st63{fill:none;stroke:#D2D2D2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:7.3685,7.3685;}\r\n\t.st64{fill:none;stroke:#D2D2D2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:6.7866,6.7866;}\r\n\t.st65{fill:none;stroke:#D2D2D2;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;stroke-dasharray:7.342,7.342;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.3,269h115c1.1,0,2.1,1.1,2.1,2.5v70.7c0,1.4-0.9,2.5-2.1,2.5h-82.4v0c-0.9,0-1.5-0.8-1.5-1.9h0v-26.9    c0-1.4-0.9-2.5-2.1-2.5h-28.7h-0.3c-1.1,0-2-1.1-2-2.5v-39.4C140.3,270.1,141.2,269,142.3,269z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.5,75.9h115c1.1,0,2.1,1.1,2.1,2.5v70.7c0,1.4-0.9,2.5-2.1,2.5h-82.4v0c-0.9,0-1.5-0.8-1.5-1.9h0v-26.9    c0-1.4-0.9-2.5-2.1-2.5h-28.7h-0.3c-1.1,0-2-1.1-2-2.5V78.4C145.4,77,146.4,75.9,147.5,75.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M142.3,460.8h115c1.1,0,2.1,1.1,2.1,2.5V534c0,1.4-0.9,2.5-2.1,2.5h-82.4v0c-0.9,0-1.5-0.8-1.5-1.9h0v-26.9    c0-1.4-0.9-2.5-2.1-2.5h-28.7h-0.3c-1.1,0-2-1.1-2-2.5v-39.4C140.3,461.9,141.2,460.8,142.3,460.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.4,76h-115c-1.1,0-2.1,1.1-2.1,2.5v70.7c0,1.4,0.9,2.5,2.1,2.5h82.4v0c0.9,0,1.5-0.8,1.5-1.9h0v-26.9    c0-1.4,0.9-2.5,2.1-2.5h28.7h0.3c1.1,0,2-1.1,2-2.5V78.6C142.5,77.2,141.6,76,140.4,76z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.5,268.9h-115c-1.1,0-2.1,1.1-2.1,2.5v70.7c0,1.4,0.9,2.5,2.1,2.5h82.4v0c0.9,0,1.5-0.8,1.5-1.9h0v-26.9    c0-1.4,0.9-2.5,2.1-2.5h28.7h0.3c1.1,0,2-1.1,2-2.5v-39.4C137.6,270,136.7,268.9,135.5,268.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.5,460.5h-115c-1.1,0-2.1,1.1-2.1,2.5v70.7c0,1.4,0.9,2.5,2.1,2.5h82.4v0c0.9,0,1.5-0.8,1.5-1.9h0v-26.9    c0-1.4,0.9-2.5,2.1-2.5h28.7h0.3c1.1,0,2-1.1,2-2.5V463C137.6,461.6,136.7,460.5,135.5,460.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_16_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.9,127.7v19.6c0,1.1-0.7,2-1.7,2h-15.2c-0.9,0-1.7-0.9-1.7-2v-19.6c0-1.1,0.7-2,1.7-2h15.2       C174.2,125.7,174.9,126.6,174.9,127.7z M174,147.3v-19.6c0-0.5-0.4-1-0.8-1h-15.2c-0.4,0-0.8,0.4-0.8,1v19.6c0,0.5,0.4,1,0.8,1       h15.2C173.7,148.3,174,147.8,174,147.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174,127.7v19.6c0,0.5-0.4,1-0.8,1h-15.2c-0.4,0-0.8-0.4-0.8-1v-19.6c0-0.5,0.4-1,0.8-1h15.2       C173.7,126.7,174,127.2,174,127.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.3,127.7v19.6c0,1.1-0.7,2-1.7,2h-15.2c-0.9,0-1.7-0.9-1.7-2v-19.6c0-1.1,0.7-2,1.7-2h15.2       C152.6,125.7,153.3,126.6,153.3,127.7z M152.5,147.3v-19.6c0-0.5-0.4-1-0.8-1h-15.2c-0.4,0-0.8,0.4-0.8,1v19.6       c0,0.5,0.4,1,0.8,1h15.2C152.1,148.3,152.5,147.8,152.5,147.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.5,127.7v19.6c0,0.5-0.4,1-0.8,1h-15.2c-0.4,0-0.8-0.4-0.8-1v-19.6c0-0.5,0.4-1,0.8-1h15.2       C152.1,126.7,152.5,127.2,152.5,127.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.7,127.7v19.6c0,1.1-0.7,2-1.7,2h-15.2c-0.9,0-1.7-0.9-1.7-2v-19.6c0-1.1,0.7-2,1.7-2H130       C130.9,125.7,131.7,126.6,131.7,127.7z M130.8,147.3v-19.6c0-0.5-0.4-1-0.8-1h-15.2c-0.4,0-0.8,0.4-0.8,1v19.6       c0,0.5,0.4,1,0.8,1H130C130.5,148.3,130.8,147.8,130.8,147.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.8,127.7v19.6c0,0.5-0.4,1-0.8,1h-15.2c-0.4,0-0.8-0.4-0.8-1v-19.6c0-0.5,0.4-1,0.8-1H130       C130.5,126.7,130.8,127.2,130.8,127.7z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_15_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.7,319.9v19.6c0,1.1-0.7,2-1.7,2h-15.2c-0.9,0-1.7-0.9-1.7-2v-19.6c0-1.1,0.7-2,1.7-2h15.2       C169,317.9,169.7,318.8,169.7,319.9z M168.9,339.5v-19.6c0-0.5-0.4-1-0.8-1h-15.2c-0.4,0-0.8,0.4-0.8,1v19.6c0,0.5,0.4,1,0.8,1       h15.2C168.5,340.5,168.9,340.1,168.9,339.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M168.9,319.9v19.6c0,0.5-0.4,1-0.8,1h-15.2c-0.4,0-0.8-0.4-0.8-1v-19.6c0-0.5,0.4-1,0.8-1h15.2       C168.5,318.9,168.9,319.4,168.9,319.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.2,319.9v19.6c0,1.1-0.7,2-1.7,2h-15.2c-0.9,0-1.7-0.9-1.7-2v-19.6c0-1.1,0.7-2,1.7-2h15.2       C147.4,317.9,148.2,318.8,148.2,319.9z M147.3,339.5v-19.6c0-0.5-0.4-1-0.8-1h-15.2c-0.4,0-0.8,0.4-0.8,1v19.6       c0,0.5,0.4,1,0.8,1h15.2C147,340.5,147.3,340.1,147.3,339.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.3,319.9v19.6c0,0.5-0.4,1-0.8,1h-15.2c-0.4,0-0.8-0.4-0.8-1v-19.6c0-0.5,0.4-1,0.8-1h15.2       C147,318.9,147.3,319.4,147.3,319.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.5,319.9v19.6c0,1.1-0.7,2-1.7,2h-15.2c-0.9,0-1.7-0.9-1.7-2v-19.6c0-1.1,0.7-2,1.7-2h15.2       C125.8,317.9,126.5,318.8,126.5,319.9z M125.7,339.5v-19.6c0-0.5-0.4-1-0.8-1h-15.2c-0.4,0-0.8,0.4-0.8,1v19.6       c0,0.5,0.4,1,0.8,1h15.2C125.3,340.5,125.7,340.1,125.7,339.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.7,319.9v19.6c0,0.5-0.4,1-0.8,1h-15.2c-0.4,0-0.8-0.4-0.8-1v-19.6c0-0.5,0.4-1,0.8-1h15.2       C125.3,318.9,125.7,319.4,125.7,319.9z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.7,511.4V531c0,1.1-0.7,2-1.7,2h-15.2c-0.9,0-1.7-0.9-1.7-2v-19.6c0-1.1,0.7-2,1.7-2h15.2       C169,509.4,169.7,510.3,169.7,511.4z M168.9,531v-19.6c0-0.5-0.4-1-0.8-1h-15.2c-0.4,0-0.8,0.4-0.8,1V531c0,0.5,0.4,1,0.8,1       h15.2C168.5,532,168.9,531.6,168.9,531z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M168.9,511.4V531c0,0.5-0.4,1-0.8,1h-15.2c-0.4,0-0.8-0.4-0.8-1v-19.6c0-0.5,0.4-1,0.8-1h15.2       C168.5,510.5,168.9,510.9,168.9,511.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.2,511.4V531c0,1.1-0.7,2-1.7,2h-15.2c-0.9,0-1.7-0.9-1.7-2v-19.6c0-1.1,0.7-2,1.7-2h15.2       C147.4,509.4,148.2,510.3,148.2,511.4z M147.3,531v-19.6c0-0.5-0.4-1-0.8-1h-15.2c-0.4,0-0.8,0.4-0.8,1V531c0,0.5,0.4,1,0.8,1       h15.2C147,532,147.3,531.6,147.3,531z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.3,511.4V531c0,0.5-0.4,1-0.8,1h-15.2c-0.4,0-0.8-0.4-0.8-1v-19.6c0-0.5,0.4-1,0.8-1h15.2       C147,510.5,147.3,510.9,147.3,511.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.5,511.4V531c0,1.1-0.7,2-1.7,2h-15.2c-0.9,0-1.7-0.9-1.7-2v-19.6c0-1.1,0.7-2,1.7-2h15.2       C125.8,509.4,126.5,510.3,126.5,511.4z M125.7,531v-19.6c0-0.5-0.4-1-0.8-1h-15.2c-0.4,0-0.8,0.4-0.8,1V531c0,0.5,0.4,1,0.8,1       h15.2C125.3,532,125.7,531.6,125.7,531z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.7,511.4V531c0,0.5-0.4,1-0.8,1h-15.2c-0.4,0-0.8-0.4-0.8-1v-19.6c0-0.5,0.4-1,0.8-1h15.2       C125.3,510.5,125.7,510.9,125.7,511.4z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_13_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M166.3,735.3v19.6c0,1.1-0.7,2-1.7,2h-15.2c-0.9,0-1.7-0.9-1.7-2v-19.6c0-1.1,0.7-2,1.7-2h15.2       C165.6,733.2,166.3,734.1,166.3,735.3z M165.4,754.8v-19.6c0-0.5-0.4-1-0.8-1h-15.2c-0.4,0-0.8,0.4-0.8,1v19.6       c0,0.5,0.4,1,0.8,1h15.2C165.1,755.8,165.4,755.4,165.4,754.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M165.4,735.3v19.6c0,0.5-0.4,1-0.8,1h-15.2c-0.4,0-0.8-0.4-0.8-1v-19.6c0-0.5,0.4-1,0.8-1h15.2       C165.1,734.3,165.4,734.7,165.4,735.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144.7,735.3v19.6c0,1.1-0.7,2-1.7,2h-15.2c-0.9,0-1.7-0.9-1.7-2v-19.6c0-1.1,0.7-2,1.7-2h15.2       C144,733.2,144.7,734.1,144.7,735.3z M143.9,754.8v-19.6c0-0.5-0.4-1-0.8-1h-15.2c-0.4,0-0.8,0.4-0.8,1v19.6c0,0.5,0.4,1,0.8,1       h15.2C143.5,755.8,143.9,755.4,143.9,754.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.9,735.3v19.6c0,0.5-0.4,1-0.8,1h-15.2c-0.4,0-0.8-0.4-0.8-1v-19.6c0-0.5,0.4-1,0.8-1h15.2       C143.5,734.3,143.9,734.7,143.9,735.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123.1,735.3v19.6c0,1.1-0.7,2-1.7,2h-15.2c-0.9,0-1.7-0.9-1.7-2v-19.6c0-1.1,0.7-2,1.7-2h15.2       C122.3,733.2,123.1,734.1,123.1,735.3z M122.2,754.8v-19.6c0-0.5-0.4-1-0.8-1h-15.2c-0.4,0-0.8,0.4-0.8,1v19.6       c0,0.5,0.4,1,0.8,1h15.2C121.9,755.8,122.2,755.4,122.2,754.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.2,735.3v19.6c0,0.5-0.4,1-0.8,1h-15.2c-0.4,0-0.8-0.4-0.8-1v-19.6c0-0.5,0.4-1,0.8-1h15.2       C121.9,734.3,122.2,734.7,122.2,735.3z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_13_",
    d: "M132.1,683.2h-115c-1.1,0-2.1,1.1-2.1,2.5v70.7c0,1.4,0.9,2.5,2.1,2.5h82.4v0c0.9,0,1.5-0.8,1.5-1.9h0        v-26.9c0-1.4,0.9-2.5,2.1-2.5h28.7h0.3c1.1,0,2-1.1,2-2.5v-39.4C134.1,684.3,133.2,683.2,132.1,683.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_15_",
    d: "M132.1,683.2h-115c-1.1,0-2.1,1.1-2.1,2.5v70.7c0,1.4,0.9,2.5,2.1,2.5h82.4v0c0.9,0,1.5-0.8,1.5-1.9h0        v-26.9c0-1.4,0.9-2.5,2.1-2.5h28.7h0.3c1.1,0,2-1.1,2-2.5v-39.4C134.1,684.3,133.2,683.2,132.1,683.2z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible",
      fill: "#099DBE"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 683.2,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 683.7,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 684.2,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 684.8,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 685.3,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 685.8,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 686.4,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 686.9,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 687.4,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 688,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 688.5,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 689,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 689.6,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 690.1,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 690.6,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 691.2,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 691.7,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 692.2,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 692.8,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 693.3,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 693.8,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 694.4,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 694.9,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 695.4,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 696,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 696.5,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 697,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 697.6,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 698.1,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 698.6,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 699.2,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 699.7,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 700.2,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 700.8,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 701.3,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 701.8,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 702.4,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 702.9,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 703.4,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 704,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 704.5,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 705,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 705.6,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 706.1,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 706.6,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 707.2,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 707.7,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 708.2,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 708.8,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 709.3,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 709.8,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 710.4,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 710.9,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 711.4,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 712,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 712.5,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 713,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 713.6,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 714.1,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 714.6,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 715.2,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 715.7,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 716.2,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 716.8,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 717.3,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 717.8,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 718.4,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 718.9,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 719.4,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 720,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 720.5,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 721,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 721.6,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 722.1,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 722.6,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 723.2,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 723.7,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 724.2,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 724.8,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 725.3,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 725.8,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 726.4,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 726.9,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 727.4,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 728,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 728.5,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 729,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 729.6,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 730.1,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 730.6,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 731.2,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 731.7,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 732.2,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 732.8,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 733.3,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 733.8,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 734.4,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 734.9,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 735.4,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 736,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 736.5,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 737,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 737.6,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 738.1,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 738.6,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 739.2,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 739.7,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 740.2,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 740.8,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 741.3,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 741.8,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 742.4,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 742.9,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 743.4,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 744,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 744.5,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 745,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 745.6,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 746.1,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 746.6,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 747.2,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 747.7,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 748.2,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 748.8,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 749.3,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 749.8,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 750.4,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 750.9,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 751.4,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 752,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 752.5,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 753,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 753.6,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 754.1,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 754.6,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 755.2,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 755.7,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 756.2,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 756.8,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 757.3,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 757.8,
    className: "st2",
    width: 119.1,
    height: 0.5
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 15.1,
    y: 758.4,
    className: "st2",
    width: 119.1,
    height: 0.5
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_17_",
    d: "M132.1,683.2h-115c-1.1,0-2.1,1.1-2.1,2.5v70.7c0,1.4,0.9,2.5,2.1,2.5h82.4v0c0.9,0,1.5-0.8,1.5-1.9h0        v-26.9c0-1.4,0.9-2.5,2.1-2.5h28.7h0.3c1.1,0,2-1.1,2-2.5v-39.4C134.1,684.3,133.2,683.2,132.1,683.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  }))))), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 24.9,
    y: 199.1,
    className: "st0",
    width: 78.1,
    height: 20.5
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 185.4,
    y: 199.1,
    className: "st0",
    width: 78.1,
    height: 20.5
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 108.3,
    y: 199.1,
    className: "st1",
    width: 72.2,
    height: 20.5
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 19.7,
    y: 583.6,
    className: "st0",
    width: 78.1,
    height: 20.5
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 180.2,
    y: 583.6,
    className: "st1",
    width: 78.1,
    height: 20.5
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 103.1,
    y: 583.6,
    className: "st0",
    width: 72.2,
    height: 20.5
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 19.7,
    y: 391.2,
    className: "st0",
    width: 78.1,
    height: 20.5
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 180.2,
    y: 391.2,
    className: "st1",
    width: 78.1,
    height: 20.5
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 103.1,
    y: 391.2,
    className: "st1",
    width: 72.2,
    height: 20.5
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 16.3,
    y: 808.1,
    className: "st1",
    width: 78.1,
    height: 20.5
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 176.8,
    y: 808.1,
    className: "st0",
    width: 78.1,
    height: 20.5
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 99.7,
    y: 808.1,
    className: "st1",
    width: 72.2,
    height: 20.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_19_",
    d: "M140.2,682.1h115c1.1,0,2.1,1.1,2.1,2.5v70.7c0,1.4-0.9,2.5-2.1,2.5h-82.4v0c-0.9,0-1.5-0.8-1.5-1.9h0        V729c0-1.4-0.9-2.5-2.1-2.5h-28.7h-0.3c-1.1,0-2-1.1-2-2.5v-39.4C138.1,683.2,139,682.1,140.2,682.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_21_",
    d: "M140.2,682.1h115c1.1,0,2.1,1.1,2.1,2.5v70.7c0,1.4-0.9,2.5-2.1,2.5h-82.4v0c-0.9,0-1.5-0.8-1.5-1.9h0        V729c0-1.4-0.9-2.5-2.1-2.5h-28.7h-0.3c-1.1,0-2-1.1-2-2.5v-39.4C138.1,683.2,139,682.1,140.2,682.1z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible",
      fill: "#099DBE"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 682.1,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 682.6,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 683.2,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 683.7,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 684.2,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 684.8,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 685.3,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 685.8,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 686.4,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 686.9,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 687.4,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 688,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 688.5,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 689,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 689.6,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 690.1,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 690.6,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 691.2,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 691.7,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 692.2,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 692.8,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 693.3,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 693.8,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 694.4,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 694.9,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 695.4,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 696,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 696.5,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 697,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 697.6,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 698.1,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 698.6,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 699.2,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 699.7,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 700.2,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 700.8,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 701.3,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 701.8,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 702.4,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 702.9,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 703.4,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 704,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 704.5,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 705,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 705.6,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 706.1,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 706.6,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 707.2,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 707.7,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 708.2,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 708.8,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 709.3,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 709.8,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 710.4,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 710.9,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 711.4,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 712,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 712.5,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 713,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 713.6,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 714.1,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 714.6,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 715.2,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 715.7,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 716.2,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 716.8,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 717.3,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 717.8,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 718.4,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 718.9,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 719.4,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 720,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 720.5,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 721,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 721.6,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 722.1,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 722.6,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 723.2,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 723.7,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 724.2,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 724.8,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 725.3,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 725.8,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 726.4,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 726.9,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 727.4,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 728,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 728.5,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 729,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 729.6,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 730.1,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 730.6,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 731.2,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 731.7,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 732.2,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 732.8,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 733.3,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 733.8,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 734.4,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 734.9,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 735.4,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 736,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 736.5,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 737,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 737.6,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 738.1,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 738.6,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 739.2,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 739.7,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 740.2,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 740.8,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 741.3,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 741.8,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 742.4,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 742.9,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 743.4,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 744,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 744.5,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 745,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 745.6,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 746.1,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 746.6,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 747.2,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 747.7,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 748.2,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 748.8,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 749.3,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 749.8,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 750.4,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 750.9,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 751.4,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 752,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 752.5,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 753,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 753.6,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 754.1,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 754.6,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 755.2,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 755.7,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 756.2,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 756.8,
    className: "st3",
    width: 119.1,
    height: 0.5
  })), _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 757.3,
    className: "st3",
    width: 119.1,
    height: 0.5
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_23_",
    d: "M140.2,682.1h115c1.1,0,2.1,1.1,2.1,2.5v70.7c0,1.4-0.9,2.5-2.1,2.5h-82.4v0c-0.9,0-1.5-0.8-1.5-1.9h0        V729c0-1.4-0.9-2.5-2.1-2.5h-28.7h-0.3c-1.1,0-2-1.1-2-2.5v-39.4C138.1,683.2,139,682.1,140.2,682.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 312.9,
    y: 171.2,
    className: "st0",
    width: 37.8,
    height: 18.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 312.7,
    cy: 467.9,
    rx: 5.6,
    ry: 6.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 325.8,
    cy: 467.9,
    rx: 5.6,
    ry: 6.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 339.3,
    cy: 467.8,
    rx: 5.6,
    ry: 6.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 351.9,
    cy: 467.8,
    rx: 5.6,
    ry: 6.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 365,
    cy: 467.9,
    rx: 5.6,
    ry: 6.6
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M378.3,683.8c-3.7,0-6.8,3.5-6.8,7.9c0,4.3,3,7.9,6.8,7.9c3.7,0,6.8-3.5,6.8-7.9    C385.1,687.4,382.1,683.8,378.3,683.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 358.3,
    cy: 692.1,
    rx: 6.8,
    ry: 7.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M338.1,684.7c-3.7,0-6.8,3.5-6.8,7.9c0,4.3,3,7.9,6.8,7.9c3.7,0,6.8-3.5,6.8-7.9    C344.9,688.2,341.8,684.7,338.1,684.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M318,684.7c-3.7,0-6.8,3.5-6.8,7.9c0,4.3,3,7.9,6.8,7.9c3.7,0,6.8-3.5,6.8-7.9    C324.7,688.2,321.7,684.7,318,684.7z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 398.7,
    cy: 692.1,
    rx: 6.8,
    ry: 7.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 520.2,
    cy: 467.8,
    rx: 5.6,
    ry: 6.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 507,
    cy: 467.8,
    rx: 5.6,
    ry: 6.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 493.5,
    cy: 467.8,
    rx: 5.6,
    ry: 6.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 480.9,
    cy: 467.8,
    rx: 5.6,
    ry: 6.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 467.9,
    cy: 467.8,
    rx: 5.6,
    ry: 6.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 516.6,
    cy: 822.2,
    rx: 6.7,
    ry: 7.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 496.4,
    cy: 822.2,
    rx: 6.7,
    ry: 7.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 476.2,
    cy: 822.2,
    rx: 6.7,
    ry: 7.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 456,
    cy: 822.2,
    rx: 6.7,
    ry: 7.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 435.9,
    cy: 822.2,
    rx: 6.7,
    ry: 7.9
  })), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 287.8,
    y1: 661,
    x2: 349.9,
    y2: 661
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 287.8,
    y1: 419.2,
    x2: 325.2,
    y2: 419.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 294.2,
    y1: 382.9,
    x2: 420.8,
    y2: 382.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 294.2,
    y1: 228,
    x2: 337.5,
    y2: 228
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 294.2,
    y1: 78.6,
    x2: 393.8,
    y2: 78.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 287.6,
    y1: 239.2,
    x2: 545.5,
    y2: 240.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 422.3,
    y1: 74.2,
    x2: 422.3,
    y2: 159.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 315.5,
    y1: 164.8,
    x2: 412.2,
    y2: 164.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 321.5,
    y1: 147.5,
    x2: 328.6,
    y2: 147.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 325.9,
    y1: 179.7,
    x2: 338.7,
    y2: 179.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 363.6,
    y1: 179.7,
    x2: 376.4,
    y2: 179.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 401.3,
    y1: 179.7,
    x2: 414.1,
    y2: 179.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 439,
    y1: 179.7,
    x2: 451.8,
    y2: 179.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 476.7,
    y1: 179.7,
    x2: 489.6,
    y2: 179.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 514.4,
    y1: 179.7,
    x2: 527.3,
    y2: 179.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 325.9,
    y1: 251.4,
    x2: 338.7,
    y2: 251.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 363.6,
    y1: 251.4,
    x2: 376.4,
    y2: 251.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 401.3,
    y1: 251.4,
    x2: 414.1,
    y2: 251.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 439,
    y1: 251.4,
    x2: 451.8,
    y2: 251.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 476.7,
    y1: 251.4,
    x2: 489.6,
    y2: 251.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 514.4,
    y1: 251.4,
    x2: 527.3,
    y2: 251.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 328.6,
    y1: 112.5,
    x2: 335.7,
    y2: 112.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 359.8,
    y1: 102,
    x2: 366.9,
    y2: 102
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 389.6,
    y1: 112.5,
    x2: 396.7,
    y2: 112.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 397.2,
    y1: 147.5,
    x2: 412.7,
    y2: 147.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 440.7,
    y1: 147.5,
    x2: 447.8,
    y2: 147.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 447.8,
    y1: 112.5,
    x2: 454.9,
    y2: 112.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 479,
    y1: 102,
    x2: 486.1,
    y2: 102
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 508.8,
    y1: 112.5,
    x2: 515.9,
    y2: 112.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 516.4,
    y1: 147.5,
    x2: 531.9,
    y2: 147.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 427.9,
    y1: 164.5,
    x2: 539.5,
    y2: 164.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M325.2,361.3l5.5-6.4c0.2-0.3,0.6-0.3,0.9,0l2,2.3c0.2,0.3,0.6,0.3,0.9,0l4.4-5.2c0,0,0-0.1,0-0.1h-2.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 338.9,
    y1: 355.4,
    x2: 338.9,
    y2: 351.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M325.2,344.9l5.5-6.4c0.2-0.3,0.6-0.3,0.9,0l2,2.3c0.2,0.3,0.6,0.3,0.9,0l4.4-5.2c0,0,0-0.1,0-0.1h-2.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 338.9,
    y1: 339,
    x2: 338.9,
    y2: 335.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M325.2,327.6l5.5-6.4c0.2-0.3,0.6-0.3,0.9,0l2,2.3c0.2,0.3,0.6,0.3,0.9,0l4.4-5.2c0,0,0-0.1,0-0.1h-2.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 338.9,
    y1: 321.7,
    x2: 338.9,
    y2: 318.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M325.2,310.3l5.5-6.4c0.2-0.3,0.6-0.3,0.9,0l2,2.3c0.2,0.3,0.6,0.3,0.9,0l4.4-5.2c0,0,0-0.1,0-0.1h-2.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 338.9,
    y1: 304.4,
    x2: 338.9,
    y2: 300.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M325.2,277.8l5.5-6.4c0.2-0.3,0.6-0.3,0.9,0l2,2.3c0.2,0.3,0.6,0.3,0.9,0l4.4-5.2c0,0,0-0.1,0-0.1h-2.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 338.9,
    y1: 271.8,
    x2: 338.9,
    y2: 268.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M363.6,361.3l5.5-6.4c0.2-0.3,0.6-0.3,0.9,0l2,2.3c0.2,0.3,0.6,0.3,0.9,0l4.4-5.2c0,0,0-0.1,0-0.1h-2.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 377.3,
    y1: 355.4,
    x2: 377.3,
    y2: 351.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M363.6,328.8l5.5-6.4c0.2-0.3,0.6-0.3,0.9,0l2,2.3c0.2,0.3,0.6,0.3,0.9,0l4.4-5.2c0,0,0-0.1,0-0.1h-2.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 377.3,
    y1: 322.8,
    x2: 377.3,
    y2: 319.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M363.6,294.1l5.5-6.4c0.2-0.3,0.6-0.3,0.9,0l2,2.3c0.2,0.3,0.6,0.3,0.9,0l4.4-5.2c0,0,0-0.1,0-0.1h-2.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 377.3,
    y1: 288.1,
    x2: 377.3,
    y2: 284.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M363.6,276.5l5.5-6.4c0.2-0.3,0.6-0.3,0.9,0l2,2.3c0.2,0.3,0.6,0.3,0.9,0l4.4-5.2c0,0,0-0.1,0-0.1h-2.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 377.3,
    y1: 270.5,
    x2: 377.3,
    y2: 267
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M401.9,361.3l5.5-6.4c0.2-0.3,0.6-0.3,0.9,0l2,2.3c0.2,0.3,0.6,0.3,0.9,0l4.4-5.2c0,0,0-0.1,0-0.1h-2.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 415.6,
    y1: 355.4,
    x2: 415.6,
    y2: 351.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M401.9,295.3l5.5-6.4c0.2-0.3,0.6-0.3,0.9,0l2,2.3c0.2,0.3,0.6,0.3,0.9,0l4.4-5.2c0,0,0-0.1,0-0.1h-2.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 415.6,
    y1: 289.4,
    x2: 415.6,
    y2: 285.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M440.2,361.3l5.5-6.4c0.2-0.3,0.6-0.3,0.9,0l2,2.3c0.2,0.3,0.6,0.3,0.9,0l4.4-5.2c0,0,0-0.1,0-0.1h-2.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 454,
    y1: 355.4,
    x2: 454,
    y2: 351.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M440.2,294.1l5.5-6.4c0.2-0.3,0.6-0.3,0.9,0l2,2.3c0.2,0.3,0.6,0.3,0.9,0l4.4-5.2c0,0,0-0.1,0-0.1h-2.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 454,
    y1: 288.1,
    x2: 454,
    y2: 284.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M440.2,276.1l5.5-6.4c0.2-0.3,0.6-0.3,0.9,0l2,2.3c0.2,0.3,0.6,0.3,0.9,0l4.4-5.2c0,0,0-0.1,0-0.1h-2.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 454,
    y1: 270.2,
    x2: 454,
    y2: 266.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M478.6,361.3l5.5-6.4c0.2-0.3,0.6-0.3,0.9,0l2,2.3c0.2,0.3,0.6,0.3,0.9,0l4.4-5.2c0,0,0-0.1,0-0.1h-2.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 492.3,
    y1: 355.4,
    x2: 492.3,
    y2: 351.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M478.6,344l5.5-6.4c0.2-0.3,0.6-0.3,0.9,0l2,2.3c0.2,0.3,0.6,0.3,0.9,0l4.4-5.2c0,0,0-0.1,0-0.1h-2.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 492.3,
    y1: 338,
    x2: 492.3,
    y2: 334.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M478.6,326.7l5.5-6.4c0.2-0.3,0.6-0.3,0.9,0l2,2.3c0.2,0.3,0.6,0.3,0.9,0l4.4-5.2c0,0,0-0.1,0-0.1h-2.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 492.3,
    y1: 320.7,
    x2: 492.3,
    y2: 317.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M478.6,309.3l5.5-6.4c0.2-0.3,0.6-0.3,0.9,0l2,2.3c0.2,0.3,0.6,0.3,0.9,0l4.4-5.2c0,0,0-0.1,0-0.1h-2.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 492.3,
    y1: 303.4,
    x2: 492.3,
    y2: 299.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M478.6,292l5.5-6.4c0.2-0.3,0.6-0.3,0.9,0l2,2.3c0.2,0.3,0.6,0.3,0.9,0l4.4-5.2c0,0,0-0.1,0-0.1h-2.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 492.3,
    y1: 286,
    x2: 492.3,
    y2: 282.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M478.6,274.7l5.5-6.4c0.2-0.3,0.6-0.3,0.9,0l2,2.3c0.2,0.3,0.6,0.3,0.9,0l4.4-5.2c0,0,0-0.1,0-0.1h-2.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 492.3,
    y1: 268.7,
    x2: 492.3,
    y2: 265.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M516.9,361.3l5.5-6.4c0.2-0.3,0.6-0.3,0.9,0l2,2.3c0.2,0.3,0.6,0.3,0.9,0l4.4-5.2c0,0,0-0.1,0-0.1h-2.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 530.6,
    y1: 355.4,
    x2: 530.6,
    y2: 351.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M516.9,327.5l5.5-6.4c0.2-0.3,0.6-0.3,0.9,0l2,2.3c0.2,0.3,0.6,0.3,0.9,0l4.4-5.2c0,0,0-0.1,0-0.1h-2.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 530.6,
    y1: 321.5,
    x2: 530.6,
    y2: 318.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M516.9,292l5.5-6.4c0.2-0.3,0.6-0.3,0.9,0l2,2.3c0.2,0.3,0.6,0.3,0.9,0l4.4-5.2c0,0,0-0.1,0-0.1h-2.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 530.6,
    y1: 286,
    x2: 530.6,
    y2: 282.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M516.9,275.1l5.5-6.4c0.2-0.3,0.6-0.3,0.9,0l2,2.3c0.2,0.3,0.6,0.3,0.9,0l4.4-5.2c0,0,0-0.1,0-0.1h-2.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 530.6,
    y1: 269.2,
    x2: 530.6,
    y2: 265.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M363.4,334.5l5.1,5.9c0.2,0.3,0.6,0.3,0.8,0l1.8-2.1c0.2-0.3,0.6-0.3,0.8,0l4.1,4.8c0,0,0,0.1,0,0.1h-2.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 376.1,
    y1: 340,
    x2: 376.1,
    y2: 343.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M363.4,302.3l5.1,5.9c0.2,0.3,0.6,0.3,0.8,0l1.8-2.1c0.2-0.3,0.6-0.3,0.8,0l4.1,4.8c0,0,0,0.1,0,0.1h-2.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 376.1,
    y1: 307.9,
    x2: 376.1,
    y2: 311.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M324.8,285l5.1,5.9c0.2,0.3,0.6,0.3,0.8,0l1.8-2.1c0.2-0.3,0.6-0.3,0.8,0l4.1,4.8c0,0,0,0.1,0,0.1h-2.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 337.5,
    y1: 290.5,
    x2: 337.5,
    y2: 293.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M402.4,334.5l5.1,5.9c0.2,0.3,0.6,0.3,0.8,0l1.8-2.1c0.2-0.3,0.6-0.3,0.8,0l4.1,4.8c0,0,0,0.1,0,0.1h-2.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 415.1,
    y1: 340,
    x2: 415.1,
    y2: 343.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M402.4,319.7l5.1,5.9c0.2,0.3,0.6,0.3,0.8,0l1.8-2.1c0.2-0.3,0.6-0.3,0.8,0l4.1,4.8c0,0,0,0.1,0,0.1h-2.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 415.1,
    y1: 325.2,
    x2: 415.1,
    y2: 328.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M402.4,303.7l5.1,5.9c0.2,0.3,0.6,0.3,0.8,0l1.8-2.1c0.2-0.3,0.6-0.3,0.8,0l4.1,4.8c0,0,0,0.1,0,0.1h-2.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 415.1,
    y1: 309.3,
    x2: 415.1,
    y2: 312.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M402.4,266.2l5.1,5.9c0.2,0.3,0.6,0.3,0.8,0l1.8-2.1c0.2-0.3,0.6-0.3,0.8,0l4.1,4.8c0,0,0,0.1,0,0.1h-2.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 415.1,
    y1: 271.8,
    x2: 415.1,
    y2: 275
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M441.3,334.5l5.1,5.9c0.2,0.3,0.6,0.3,0.8,0l1.8-2.1c0.2-0.3,0.6-0.3,0.8,0l4.1,4.8c0,0,0,0.1,0,0.1h-2.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 454,
    y1: 340,
    x2: 454,
    y2: 343.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M441.3,318.6l5.1,5.9c0.2,0.3,0.6,0.3,0.8,0l1.8-2.1c0.2-0.3,0.6-0.3,0.8,0l4.1,4.8c0,0,0,0.1,0,0.1h-2.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 454,
    y1: 324.1,
    x2: 454,
    y2: 327.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M441.3,302.6l5.1,5.9c0.2,0.3,0.6,0.3,0.8,0l1.8-2.1c0.2-0.3,0.6-0.3,0.8,0l4.1,4.8c0,0,0,0.1,0,0.1h-2.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 454,
    y1: 308.1,
    x2: 454,
    y2: 311.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M517.4,334.5l5.1,5.9c0.2,0.3,0.6,0.3,0.8,0l1.8-2.1c0.2-0.3,0.6-0.3,0.8,0l4.1,4.8c0,0,0,0.1,0,0.1h-2.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 530.1,
    y1: 340,
    x2: 530.1,
    y2: 343.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M517.4,300.5l5.1,5.9c0.2,0.3,0.6,0.3,0.8,0l1.8-2.1c0.2-0.3,0.6-0.3,0.8,0l4.1,4.8c0,0,0,0.1,0,0.1h-2.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 530.1,
    y1: 306,
    x2: 530.1,
    y2: 309.2
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M338.9,148.5c0,0,0.9-27.7,23.7-27.7s23.5,27.5,23.5,27.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M460.7,148.5c0,0,0.9-27.7,23.7-27.7c22.8,0,23.5,27.5,23.5,27.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 362.6,
    y1: 146.8,
    x2: 363.3,
    y2: 129.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 484.2,
    y1: 146.8,
    x2: 489.6,
    y2: 131.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.5,
    y: 608.6,
    className: "st0",
    width: 37.8,
    height: 18.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 325.5,
    y1: 617.1,
    x2: 338.4,
    y2: 617.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 363.2,
    y1: 617.1,
    x2: 376.1,
    y2: 617.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 400.9,
    y1: 617.1,
    x2: 413.8,
    y2: 617.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 438.6,
    y1: 617.1,
    x2: 451.5,
    y2: 617.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 476.3,
    y1: 617.1,
    x2: 489.2,
    y2: 617.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 514,
    y1: 617.1,
    x2: 526.9,
    y2: 617.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 312.5,
    y1: 472,
    x2: 312.5,
    y2: 475.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st41",
    x1: 312.5,
    y1: 482.1,
    x2: 312.5,
    y2: 584.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 312.5,
    y1: 587.9,
    x2: 312.5,
    y2: 591.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 325.2,
    y1: 472,
    x2: 325.2,
    y2: 475.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st42",
    x1: 325.2,
    y1: 482.8,
    x2: 325.2,
    y2: 567.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 325.2,
    y1: 570.8,
    x2: 325.2,
    y2: 574.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 339.3,
    y1: 472,
    x2: 339.3,
    y2: 475.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st43",
    x1: 339.3,
    y1: 482.4,
    x2: 339.3,
    y2: 547.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 339.3,
    y1: 550.9,
    x2: 339.3,
    y2: 554.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 351.9,
    y1: 472,
    x2: 351.9,
    y2: 475.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st44",
    x1: 351.9,
    y1: 481.9,
    x2: 351.9,
    y2: 529.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 351.9,
    y1: 532.8,
    x2: 351.9,
    y2: 536.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 365,
    y1: 472,
    x2: 365,
    y2: 475.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st45",
    x1: 365,
    y1: 483.4,
    x2: 365,
    y2: 511.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 365,
    y1: 515.1,
    x2: 365,
    y2: 518.6
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M310.4,594.8l105.1-146.6c0.8-1.1,2.2-1.1,2.9,0L523,594.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 376.9,
    y1: 574.3,
    x2: 376.9,
    y2: 570.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st46",
    x1: 376.9,
    y1: 563.6,
    x2: 376.9,
    y2: 510.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 376.9,
    y1: 506.6,
    x2: 376.9,
    y2: 503.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 317.8,
    y1: 812.6,
    x2: 317.8,
    y2: 811.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st47",
    x1: 317.8,
    y1: 808.2,
    x2: 317.8,
    y2: 697.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 317.8,
    y1: 696,
    x2: 317.8,
    y2: 694.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 338.1,
    y1: 801.1,
    x2: 338.1,
    y2: 799.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st48",
    x1: 338.1,
    y1: 796.6,
    x2: 338.1,
    y2: 697.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 338.1,
    y1: 696,
    x2: 338.1,
    y2: 694.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 358.5,
    y1: 789.3,
    x2: 358.5,
    y2: 787.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st49",
    x1: 358.5,
    y1: 784.9,
    x2: 358.5,
    y2: 697.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 358.5,
    y1: 696,
    x2: 358.5,
    y2: 694.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 378.9,
    y1: 781.6,
    x2: 378.9,
    y2: 780.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st50",
    x1: 378.9,
    y1: 777.2,
    x2: 378.9,
    y2: 697.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 378.9,
    y1: 696,
    x2: 378.9,
    y2: 694.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 399.2,
    y1: 772.4,
    x2: 399.2,
    y2: 770.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st51",
    x1: 399.2,
    y1: 767.9,
    x2: 399.2,
    y2: 697.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 399.2,
    y1: 696,
    x2: 399.2,
    y2: 694.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 517,
    y1: 709.1,
    x2: 517,
    y2: 710.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st47",
    x1: 517,
    y1: 713.5,
    x2: 517,
    y2: 812.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 517,
    y1: 813.9,
    x2: 517,
    y2: 815.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 496.6,
    y1: 720.8,
    x2: 496.6,
    y2: 722.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st52",
    x1: 496.6,
    y1: 725.3,
    x2: 496.6,
    y2: 812.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 496.6,
    y1: 813.9,
    x2: 496.6,
    y2: 815.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 476.2,
    y1: 732.6,
    x2: 476.2,
    y2: 734.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st53",
    x1: 476.2,
    y1: 737,
    x2: 476.2,
    y2: 812.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 476.2,
    y1: 813.9,
    x2: 476.2,
    y2: 815.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 455.9,
    y1: 745.6,
    x2: 455.9,
    y2: 747.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st54",
    x1: 455.9,
    y1: 750,
    x2: 455.9,
    y2: 812.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st15",
    x1: 455.9,
    y1: 813.9,
    x2: 455.9,
    y2: 815.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 435.5,
    y1: 754.8,
    x2: 435.5,
    y2: 756.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st55",
    x1: 435.5,
    y1: 759.4,
    x2: 435.5,
    y2: 812.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 435.5,
    y1: 813.9,
    x2: 435.5,
    y2: 815.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 389.6,
    y1: 574.3,
    x2: 389.6,
    y2: 570.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st56",
    x1: 389.6,
    y1: 564.3,
    x2: 389.6,
    y2: 489.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 389.6,
    y1: 486.7,
    x2: 389.6,
    y2: 483.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 403.1,
    y1: 574.3,
    x2: 403.1,
    y2: 570.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st57",
    x1: 403.1,
    y1: 563.9,
    x2: 403.1,
    y2: 471.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 403.1,
    y1: 468.3,
    x2: 403.1,
    y2: 464.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 416.7,
    y1: 574.3,
    x2: 416.7,
    y2: 570.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st58",
    x1: 416.7,
    y1: 563.8,
    x2: 416.7,
    y2: 455.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 416.7,
    y1: 451.7,
    x2: 416.7,
    y2: 448.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 430.2,
    y1: 574.3,
    x2: 430.2,
    y2: 570.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st59",
    x1: 430.2,
    y1: 564,
    x2: 430.2,
    y2: 473.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 430.2,
    y1: 469.8,
    x2: 430.2,
    y2: 466.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 443.7,
    y1: 574.3,
    x2: 443.7,
    y2: 570.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st60",
    x1: 443.7,
    y1: 563.3,
    x2: 443.7,
    y2: 492.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 443.7,
    y1: 489.1,
    x2: 443.7,
    y2: 485.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 456.5,
    y1: 574.3,
    x2: 456.5,
    y2: 570.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st46",
    x1: 456.5,
    y1: 563.6,
    x2: 456.5,
    y2: 510.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 456.5,
    y1: 506.6,
    x2: 456.5,
    y2: 503.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 468,
    y1: 517.7,
    x2: 468,
    y2: 514.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st61",
    x1: 468,
    y1: 506.4,
    x2: 468,
    y2: 479.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 468,
    y1: 475.5,
    x2: 468,
    y2: 472
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 480.8,
    y1: 536.3,
    x2: 480.8,
    y2: 532.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st62",
    x1: 480.8,
    y1: 525.8,
    x2: 480.8,
    y2: 473.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 480.8,
    y1: 469.8,
    x2: 480.8,
    y2: 466.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 493.9,
    y1: 555.6,
    x2: 493.9,
    y2: 552.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st63",
    x1: 493.9,
    y1: 544.8,
    x2: 493.9,
    y2: 474.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 493.9,
    y1: 471.1,
    x2: 493.9,
    y2: 467.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 520.2,
    y1: 589.9,
    x2: 520.2,
    y2: 586.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st64",
    x1: 520.2,
    y1: 579.7,
    x2: 520.2,
    y2: 474.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 520.2,
    y1: 471.1,
    x2: 520.2,
    y2: 467.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 507,
    y1: 571.2,
    x2: 507,
    y2: 567.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st65",
    x1: 507,
    y1: 560.4,
    x2: 507,
    y2: 475.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 507,
    y1: 472.3,
    x2: 507,
    y2: 468.8
  })), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 304.9,
    y1: 523.1,
    x2: 525.9,
    y2: 523.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 304.9,
    y1: 764.9,
    x2: 525.9,
    y2: 764.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 416.7,
    y1: 684.7,
    x2: 416.7,
    y2: 828.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 411.3,
    y1: 775.5,
    x2: 399.2,
    y2: 775.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 411.3,
    y1: 787.2,
    x2: 378.9,
    y2: 787.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 411.3,
    y1: 799,
    x2: 358.5,
    y2: 799
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 411.3,
    y1: 810.7,
    x2: 338.1,
    y2: 810.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 411.3,
    y1: 822.5,
    x2: 317.2,
    y2: 822.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 422.8,
    y1: 756.1,
    x2: 434.8,
    y2: 756.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 422.8,
    y1: 744.3,
    x2: 455.2,
    y2: 744.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 422.8,
    y1: 732.6,
    x2: 475.5,
    y2: 732.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 422.8,
    y1: 720.8,
    x2: 495.9,
    y2: 720.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 422.8,
    y1: 709.1,
    x2: 516.8,
    y2: 709.1
  }))), _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    x: 19.3,
    y: 20.6,
    className: "st0",
    width: 111.7,
    height: 27
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 345.5,
    cy: 25.1,
    rx: 1.9,
    ry: 2.1
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 549.1,
    y: 60.6,
    className: "st1",
    width: 0.8,
    height: 791.6
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 370,
    y1: 13.7,
    x2: 415.5,
    y2: 13.7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 370,
    y1: 27.9,
    x2: 392.7,
    y2: 27.9
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 370,
    y1: 42,
    x2: 392.7,
    y2: 42
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 422.1,
    y1: 27.9,
    x2: 444.9,
    y2: 27.9
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 422.1,
    y1: 42,
    x2: 444.9,
    y2: 42
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 474.1,
    y1: 27.9,
    x2: 496.9,
    y2: 27.9
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 474.1,
    y1: 42,
    x2: 496.9,
    y2: 42
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 422.1,
    y1: 13.7,
    x2: 462.2,
    y2: 13.7
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 474.1,
    y1: 13.7,
    x2: 505.6,
    y2: 13.7
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 520.6,
    y1: 27.9,
    x2: 574,
    y2: 27.9
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 520.6,
    y1: 42,
    x2: 574,
    y2: 42
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 520.6,
    y1: 13.7,
    x2: 574,
    y2: 13.7
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 581.8,
    y1: 27.9,
    x2: 626.4,
    y2: 27.9
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 581.8,
    y1: 42,
    x2: 626.4,
    y2: 42
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 581.8,
    y1: 13.7,
    x2: 626.4,
    y2: 13.7
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 633.5,
    y1: 27.9,
    x2: 637,
    y2: 27.9
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 633.5,
    y1: 42,
    x2: 637,
    y2: 42
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 633.5,
    y1: 13.7,
    x2: 637,
    y2: 13.7
  })), _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    x: 287,
    y: 8.3,
    className: "st1",
    width: 68.1,
    height: 42.8
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 273.1,
    y: 0,
    className: "st1",
    width: 0.8,
    height: 852.8
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 62,
    className: "st1",
    width: 1332.3,
    height: 0.8
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 546.1,
    y: 678.9,
    className: "st1",
    width: 783.4,
    height: 0.8
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st37"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1007.1,
    y: 182.2,
    className: "st0",
    width: 144.1,
    height: 142.3
  })), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 1150.8,
    y1: 253,
    x2: 1333.3,
    y2: 253
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 1150.8,
    y1: 182.2,
    x2: 1333.3,
    y2: 182.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 1007.3,
    y1: 61.9,
    x2: 1007.3,
    y2: 677.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 1150.7,
    y1: 61.9,
    x2: 1150.7,
    y2: 677.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 1152.3,
    y1: 323.5,
    x2: 1334.8,
    y2: 323.5
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M555.1,313.1c12.4,3.3,24.6,7,36.8,11c7.5,2.5,15.3,5,22.3,8.7c2.5,1.4,3.7,2.4,5.2,4.7    c11.9,18.6,21.2,39.1,31.2,58.8c15.3,30.1,30.4,60.4,45.5,90.7c10.9,21.9,21.7,43.9,32.5,65.8c1.8,3.8,2.8,6.4,6.1,8.9    c11.4,8.6,22.8,17.1,34.2,25.7c1.1,0.8,2.1,1.6,3.2,2.4c0.6,0.5,1.7,0.1,2.1-0.5c10.6-18.4,21.3-36.9,31.9-55.3    c19.6-33.9,39.1-67.7,58.7-101.6c7.3-12.7,14.6-25.3,21.9-38c2.6-4.5,6-9.1,8-14c3.4-8.1,5.3-17.1,7.9-25.4    c5.5-17.5,11-35.1,16.4-52.6c5.7-18.3,11.4-36.6,17.1-54.9c2.1-6.8,4.3-13.7,6.4-20.5c1.2-3.8,2.9-7.8,3.6-11.7    c0.1-0.5,0.3-1.1,0.5-1.6c-0.5,0.4-1,0.7-1.4,1.1c34-2.6,68.1-5.2,102.1-7.8c8.3-0.6,16.6-1.3,25-1.9c2.4-0.2,4.8-0.4,7.2-0.5    c0.6,0,1.2,0,1.7-0.1c1-0.2-0.3-0.3-0.5-0.4c3.9,3.1,7.3,7.5,10.8,11.1c7.3,7.5,14.6,14.9,21.9,22.4    c12.3,12.6,24.6,25.2,36.9,37.9c0.6,0.6,1.5,0.5,2.1,0c12.7-11.4,25.4-22.8,38.2-34.2c8.7-7.8,17.3-15.5,26-23.3    c3.9-3.5,8.8-6.9,12.2-10.9c2.9-3.4,4.9-8,7.1-11.8c5.8-9.5,11.5-19.1,17.3-28.6c10.4-17.3,20.8-34.5,31.2-51.8    c0.3-0.5,0.9-1.2,1.1-1.8c-0.4,1.2-1.9,0.3,0.4,0.5c5.2,0.5,11-0.5,16.2-0.7c10.2-0.4,20.4-0.9,30.6-1.3c1.9-0.1,1.9-3.1,0-3    c-8.9,0.4-17.8,0.8-26.7,1.2c-5.5,0.2-10.9,0.5-16.4,0.7c-2,0.1-5-0.4-6.6,1c-0.9,0.8-1.6,2.6-2.2,3.6c-1.9,3.2-3.9,6.4-5.8,9.6    c-5.8,9.7-11.6,19.3-17.5,29c-10.1,16.8-20,33.8-30.4,50.4c-0.9,1.4-0.3,0.6-1.3,1.6c-2,1.9-4.2,3.7-6.3,5.6    c-7.9,7.1-15.8,14.2-23.7,21.2c-15.2,13.6-30.4,27.2-45.5,40.9c0.7,0,1.4,0,2.1,0c-10.5-10.7-20.9-21.4-31.4-32.2    c-12.4-12.7-24.3-26.4-37.4-38.4c-2-1.8-3.6-1.2-6.3-1c-7.1,0.5-14.2,1.1-21.2,1.6c-22,1.7-44.1,3.4-66.1,5    c-14.9,1.1-29.9,2.3-44.8,3.4c-0.7,0.1-1.2,0.4-1.4,1.1c-7.7,24.6-15.4,49.3-23.1,73.9c-9.4,30-18.8,60.1-28.2,90.1    c-1.1,3.4-2.9,6.3-5.2,10.2c-6.4,11.1-12.9,22.3-19.3,33.4c-19.3,33.4-38.6,66.9-57.9,100.3c-8.3,14.3-16.6,28.7-24.8,43    c-2.8,4.9-5.7,9.8-8.5,14.7c-1.4,2.4-3.8,5.3-4.6,8c-0.1,0.4-0.4,0.7-0.6,1c0.7-0.2,1.4-0.4,2.1-0.5    c-10.1-7.6-20.3-15.2-30.4-22.8c-2.3-1.7-4.6-3.5-6.9-5.2c-0.7-0.5-2.6-2.5-1.8-1.2c-0.8-1.1-1.3-2.6-1.8-3.8    c-10.1-20.5-20.2-41-30.3-61.4c-15.1-30.5-30.3-60.9-45.6-91.2c-10.8-21.3-21.2-43-33.4-63.5c-1-1.7-2-3.6-3.4-5    c-3.6-3.7-9.8-5.5-14.5-7.3c-15-5.8-30.5-10.3-46-14.6c-1.1-0.3-2.3-0.6-3.4-0.9C554,309.7,553.2,312.6,555.1,313.1L555.1,313.1z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 555.4,
    y1: 734.9,
    x2: 587.3,
    y2: 734.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 555.4,
    y1: 708.5,
    x2: 568.5,
    y2: 708.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 628.3,
    y1: 708.5,
    x2: 641.3,
    y2: 708.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 709.3,
    y1: 708.5,
    x2: 722.3,
    y2: 708.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 628.7,
    y1: 734.9,
    x2: 660.6,
    y2: 734.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 859.3,
    y1: 734.9,
    x2: 873.2,
    y2: 734.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 859.3,
    y1: 762.7,
    x2: 873.2,
    y2: 762.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 859.3,
    y1: 790.4,
    x2: 873.2,
    y2: 790.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 628.7,
    y1: 762.3,
    x2: 660.6,
    y2: 762.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 708.3,
    y1: 734.5,
    x2: 769.3,
    y2: 734.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 708.3,
    y1: 762.4,
    x2: 769.3,
    y2: 762.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 708.3,
    y1: 790.3,
    x2: 769.3,
    y2: 790.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 628.7,
    y1: 789.7,
    x2: 660.6,
    y2: 789.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 555.4,
    y1: 762.4,
    x2: 587.3,
    y2: 762.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 551.3,
    y1: 719.5,
    x2: 1332.5,
    y2: 719.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 551.3,
    y1: 749.1,
    x2: 1332.5,
    y2: 749.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 551.3,
    y1: 775.6,
    x2: 1332.5,
    y2: 775.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 551.3,
    y1: 802.1,
    x2: 1332.5,
    y2: 802.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 551.3,
    y1: 828.5,
    x2: 1332.5,
    y2: 828.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 555.4,
    y1: 789.9,
    x2: 587.3,
    y2: 789.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 555.4,
    y1: 815.4,
    x2: 612.3,
    y2: 815.4
  }))), _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    x: 1212.8,
    y: 24.2,
    className: "st0",
    width: 111.7,
    height: 27
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 1077.8,
    y1: 8.8,
    x2: 1198.8,
    y2: 8.8
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 1077.8,
    y1: 38.1,
    x2: 1150.2,
    y2: 38.1
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 1251.5,
    y1: 8.8,
    x2: 1310.4,
    y2: 8.8
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 1251.5,
    y1: 38.1,
    x2: 1310.4,
    y2: 38.1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeAdvanced);
export default __webpack_public_path__ + "static/media/theme-advanced.0184bdc8b8b535a032ec14cb9debcfb1.svg";
export { ForwardRef as ReactComponent };